"use strict";

exports.__esModule = true;
exports.compactQuery = compactQuery;
exports.getLocationQuery = getLocationQuery;
exports.getScreenLocation = getScreenLocation;
exports.getScreenPath = getScreenPath;
exports.getScreenURL = getScreenURL;
exports.setScreenPath = setScreenPath;
exports.setScreenPaths = setScreenPaths;
var _querystring = require("querystring");
var SCREEN_PATHS = {
  AdminConfiguration: "/admin-configuration",
  About: "/about",
  ReportList: "/reports",
  Report: "/reports/:id",
  CreateReport: "/reports/create",
  UpdateReport: "/reports/:id/update",
  DashboardList: "/dashboards",
  Dashboard: "/dashboards/:id",
  CreateDashboard: "/dashboards/create",
  UpdateDashboard: "/dashboards/:id/update",
  OperatorPanelList: "/operator-panels",
  OperatorPanel: "/operator-panels/:id",
  CreateOperatorPanel: "/operator-panels/create",
  UpdateOperatorPanel: "/operator-panels/:id/update",
  WorkInstructionList: "/knowledge-base",
  WorkInstruction: "/knowledge-base/:id",
  UpdateWorkInstruction: "/knowledge-base/:id/update",
  PlantStateActivities: "/plant-state-activities/:id?",
  CreatePlantStateActivities: "/plant-state-activities/create",
  UpdatePlantStateActivities: "/plant-state-activities/:id",
  DeviceList: "/devices/:id?",
  UpdateDevice: "/devices/:id/update",
  PlantTwin: "/plant-twin",
  DeviceListPlantTwin: "/plant-twin/:id?",
  UpdateDevicePlantTwin: "/plant-twin/:id/update",
  CreateDevicePlantTwin: "/plant-twin/create",
  UserList: "/users/:id?",
  CreateUser: "/users/create",
  UpdateUser: "/users/:id/update",
  ResetPassword: "/reset-password",
  ForgotPassword: "/forgot-password",
  TargetsList: "/targets/:id?",
  CreateTarget: "/targets/create",
  UpdateTarget: "/targets/:id/update",
  Calendar: "/calendar",
  ScheduleList: "/calendar/schedules",
  CreateSchedule: "/calendar/create-schedule",
  UpdateSchedule: "/calendar/schedules/:id",
  CalendarSettings: "/calendar/settings",
  TicketTypes: "/ticket-types/:id?",
  CreateTicketType: "/ticket-types/create",
  UpdateTicketType: "/ticket-types/:id/update",
  TicketWatcherRuleList: "/ticketing/watcher-rules/:id?",
  CreateTicketWatcherRule: "/ticketing/watcher-rules/create",
  UpdateTicketWatcherRule: "/ticketing/watcher-rules/:id",
  TicketDetails: "/ticketing/:id",
  TicketList: "/ticketing",
  AlertList: "/alerts",
  AlertDetails: "/alerts/:id",
  AlertWatcherRuleList: "/alerts/watcher-rules/:id?",
  CreateAlertWatcherRule: "/alerts/watcher-rules/create",
  UpdateAlertWatcherRule: "/alerts/watcher-rules/:id",
  AlertsAnalysis: "/alerts-analysis",
  AlertsCreation: "/alerts-creation",
  ExportDeviceData: "/device-data",
  RuleConfiguration: "/rule-config",
  RuleConfigurationUI: "/device-rule-config",
  ElevateLandingScreen: "/",
  DecisionTreeList: "/decision-tree/nodes",
  DecisionTreeNodeDetails: "/decision-tree/node/:parentId/:id",
  DecisionTreeUpdateNode: "/decision-tree/node/:parentId/:id?/update",
  DataOnDemandScreen: "/data-on-demand/:id?",
  DataOnDemandDetailsScreen: "/data-on-demand/:id",
  CreateDataOnDemandScreen: "/data-on-demand/create",
  PlanList: "/maintenance-manager/plans/:mode",
  CreatePlan: "/maintenance-manager/create",
  UpdatePlan: "/maintenance-manager/:id/update",
  ViewPlan: "/maintenance-manager/:id",
  ActivitiesList: "/maintenance-manager/activities",
  MaintenanceManagerLanding: "/maintenance-manager",
  PredefinedComments: "/predefined-comments",
  AuditLogList: "/audit-log",
  AuditLogDetails: "/audit-log/:id",
  HistoricalPartCountListScreen: "/historical-part-count",
  UserNotifications: "/notifications/:id?",
  CreateUserNotification: "/notifications/create",
  UpdateUserNotification: "/notifications/:id/update"
};
var URL_CREATORS = {};

/**
 * Get the path to a given screen.
 * @throws {Error} if the path does not exist.
 */
function getScreenPath(screenName) {
  var path = SCREEN_PATHS[screenName];
  if (path === undefined) {
    throw new Error("No such screen: " + screenName);
  }
  return path;
}

/**
 * Set the path of an individual screen.
 */
function setScreenPath(screenName, path) {
  SCREEN_PATHS[screenName] = path;
}

/**
 * Set custom paths for screens.
 */
function setScreenPaths(paths) {
  Object.assign(SCREEN_PATHS, paths);
}
var PATH_REGEXP = new RegExp([
// Match escaped characters that would otherwise appear in future matches.
// This allows the user to escape special characters that won't transform.
"(\\\\.)",
// Match Express-style parameters and un-named parameters with a prefix
// and optional suffixes. Matches appear as:
//
// "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?"]
// "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined]
"(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?"].join("|"), "g");

/**
 * Given a path-to-regexp compatible path, return a function
 * which can create corresponding URLs.
 */
function makeURLCreator(path) {
  var res;
  var parts = [];
  var currentIndex = 0;
  // eslint-disable-next-line no-cond-assign
  while (res = PATH_REGEXP.exec(path)) {
    var key = res[2];
    var optional = res[5] === "?";
    var _res = res,
      index = _res.index;
    var length = res[0].length;
    if (currentIndex < index) {
      parts.push(path.slice(currentIndex, index));
    }
    parts.push({
      key: key,
      optional: optional
    });
    currentIndex = index + length;
  }
  if (currentIndex < path.length - 1) {
    parts.push(path.slice(currentIndex));
  }
  return function (params, query) {
    var pathname = [];
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      if (typeof part === "object" && part !== null) {
        if (!params) {
          if (part.optional) {
            continue;
          }
          throw new Error("Cannot create URL for " + path + " without parameters");
        }
        pathname.push(params[part.key]);
      } else {
        pathname.push(part);
      }
    }
    if (query != null) {
      var search = (0, _querystring.stringify)(query);
      if (search) {
        return {
          pathname: pathname.join(""),
          search: "?" + search
        };
      }
    }
    return {
      pathname: pathname.join(""),
      search: ""
    };
  };
}
function getURLCreator(path) {
  var existing = URL_CREATORS[path];
  if (typeof existing === "function") {
    return existing;
  }
  var creator = makeURLCreator(path);
  URL_CREATORS[path] = creator;
  return creator;
}

/**
 * Get the URL for a specific screen.
 */
function getScreenURL(screenName, params, query) {
  var path = getScreenPath(screenName);
  var urlCreator = getURLCreator(path);
  var _urlCreator = urlCreator(params, query),
    pathname = _urlCreator.pathname,
    search = _urlCreator.search;
  if (search) {
    return pathname.concat(search);
  }
  return pathname;
}
function getScreenLocation(screenName, params, query) {
  var path = getScreenPath(screenName);
  var urlCreator = getURLCreator(path);
  return urlCreator(params, query);
}
function getLocationQuery(location) {
  var search = location.search;
  if (!search || search === "?") {
    return {};
  }
  return (0, _querystring.parse)(search.startsWith("?") ? search.slice(1) : search);
}

/**
 * A copy of a query object without empty values, for carrying the current
 * filters (device, period, tags) along to another screen and back.
 */
function compactQuery(query) {
  if (!query) {
    return {};
  }
  return Object.fromEntries(Object.entries(query).filter(function (_ref) {
    var value = _ref[1];
    return value != null && value !== "" && !(Array.isArray(value) && value.length === 0);
  }));
}